module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_17 (24).155425d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_17 (24).mp4
// module id = 799
// module chunks = 1